import React from 'react';
import PrcingPreview from '../components/PrcingPreview';
// @ts-ignore: module has no declaration file
import useDynamicSEO from '../hooks/dynamicSEO';

const Pricing: React.FC = () => {
        useDynamicSEO({
      title:"Pricing Plans – Smart Parking Automation App | Park Hive",
      description:"Choose the right pricing plan — flexible, scalable, transparent. Park Hive offers cost-effective automation, real-time monitoring, and full revenue control.",
      keywords:["Parking Management System","Event & Exhibition Parking Management","Parking Lot Management App","Digital Parking Solutions"," Vehicle entry exit management system","AI Parking Management Platform","Parking Lot Automation Software", "Parking revenue management app", "Tourist Attraction Parking Software", "Cinema & Multiplex Parking System"],
      ogTitle:"Pricing Plans – Smart Parking Automation App | Park Hive",
      ogDescription:"Choose the right pricing plan — flexible, scalable, transparent. Park Hive offers cost-effective automation, real-time monitoring, and full revenue control."
      
      })
  return (
    <div className="pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Simple, Transparent Pricing
          </h1>
          <p className="text-lg text-gray-600">
            Choose the perfect plan for your parking business and start maximizing your revenue today.
          </p>
           <PrcingPreview></PrcingPreview>
        </div>
      </div>
           

    </div>
  );
};

export default Pricing;